export const SCHOOL_PAYMENTS = [
  { key: 'Amount', label: 'Amount', field: 'amount', isAmount: true },
  { key: 'Product', label: 'Product', field: 'product' },
  { key: 'Reference', label: 'Reference', field: 'reference' },
  { key: 'RRR', label: 'RRR', field: 'retrieval_reference' },
  { key: 'Date Updated', label: 'Date Updated', field: 'updated_at', isDate: true },
  { key: 'Status', label: 'Status', field: 'status', isStatus: true },
];

export const TRANSACTIONS = [
  { key: 'Account Name', label: 'Account Name', field: 'account_name' },
  { key: 'Account Number', label: 'Account Number', field: 'account_number' },
  { key: 'Amount', label: 'Amount', field: 'amount', isAmount: true },
  { key: 'Channel', label: 'Channel', field: 'channel' },
  { key: 'Product', label: 'Product', field: 'product' },
  { key: 'Provider', label: 'Provider', field: 'provider' },
  { key: 'Reference', label: 'Reference', field: 'reference' },
  { key: 'Date', label: 'Date', field: 'updated_at', isDate: true },
  { key: 'Status', label: 'Status', field: 'status', isStatus: true },
];

export const USERS = [
  { key: 'First Name', label: 'First Name', field: 'first_name' },
  { key: 'Last Name', label: 'Last Name', field: 'last_name' },
  { key: 'Middle Name', label: 'Middle Name', field: 'middle_name' },
  { key: 'Email', label: 'Email', field: 'email' },
  { key: 'Phone Number', label: 'Phone Number', field: 'phone_number' },
  { key: 'User Type', label: 'User Type', field: 'user_type' },
  // { key: 'Department', label: 'Department', field: 'department' },
  // { key: 'Status', label: 'Status', field: 'status', isStatus: true },
];

export const ACTIVITY_COLUMNS = [
  { key: "Name", label: "Name" },
  { key: "Email", label: "Email" },
  { key: "Action", label: "Action" },
  { key: "Date", label: "Date" },
];

export const EXPORT_CONFIGS = {
  schoolPayments: {
    endpoint: '/v1/admin/dashboard/school-payment-records/download',
    baseFilename: 'school-payments',
    timeout: 60000,
  },
  transactions: {
    endpoint: '/v1/admin/dashboard/transactions/download-transaction-records',
    baseFilename: 'transactions',
    timeout: 60000,
  },
};